import {Fragment, h, render} from 'preact';
import {Dialog} from "./Dialog/Dialog";


(() => {
    function Modal({content}) {

        return (<Dialog>
            {({isOpen, onOpen, onDialogClick, onClose}) => (
                <Fragment>
                    <button type="button" onclick={onOpen} className="openBtn aActionButton">
                        Partager
                    </button>
                    <aside
                        onClick={onClose}
                        className={`oModal ${isOpen ? `open` : ``}`}
                    >
                        {isOpen ? (
                            <section onClick={onDialogClick} className="oModal__Dialog">
                                <div className="header">
                                    <button type="button" onClick={onClose}>
                                        X
                                    </button>
                                </div>
                                <div className="content" innerHTML={content}></div>
                            </section>
                        ) : null}
                    </aside>
                </Fragment>
            )}
        </Dialog>);
    }


    window.addEventListener('DOMContentLoaded', () => {
        const nodesList = document.querySelectorAll('[data-component="ModalDialog"]');
        const initModal = (element) => {
            if (!element) {
                return;
            }
            const id = element.id;
            const modal = document.querySelector(`#${id}`);
            if (!modal) return;
            const content = modal.innerHTML;
            modal.firstChild.remove();

            render(<Modal content={content} />, modal);
        };

        nodesList.forEach((item) => {
            initModal(item);
        });
    });
})();
